import React from 'react'
import caretDown from '../../../../../img/caretDownGeneric.svg'
import Tooltip from '@mui/material/Tooltip'
import styles from './styles.module.css'
import infoIcon from '../../images/circle-info-regular-full.svg'

const titleOptions = [
  { label: 'Owner', value: 'Owner' },
  { label: 'Agent', value: 'Agent' },
  { label: 'Listing Agent', value: 'Listing Agent' },
  { label: 'Host', value: 'Host' }
]

export default function PeopleTitle ({ localPeopleData, setLocalPeopleData }) {
  return (
    <section className={styles.propertyTypeSection}>
      <div className={styles.sectionTitleWithIcon}>
        <label className={styles.titleSizeSection} htmlFor='title'>
          Title
        </label>
        <Tooltip
          title='Filter by the person’s role associated with the property'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '.MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='Title help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>

      <select
        id='title'
        name='title'
        value={localPeopleData.title}
        onChange={e =>
          setLocalPeopleData({
            ...localPeopleData,
            title: e.target.value
          })
        }
        className={styles.selectSize}
      >
        <option value=''>Select</option>
        {titleOptions.map((opt, idx) => (
          <option key={idx} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <img src={caretDown} alt='arrow' className={styles.customArrowPrice} />
    </section>
  )
}
